import { Range } from 'utils/helperFunctions';
import { CombineTypeAnswer } from 'views/pages/questionBank/questionAdd/types';
import { ISectionGroup } from 'views/pages/survey/type';
export type TtypeRating = 'number' | 'star';
export type TBgColor = 'yellowMain' | 'orangeDark';
export const TypeRating: { [key in TtypeRating]: TtypeRating } = {
  number: 'number',
  star: 'star',
};
export const BgColorRating: { [key in TBgColor]: TBgColor } = {
  yellowMain: 'yellowMain',
  orangeDark: 'orangeDark',
};

export interface ISelectedItem {
  id: number;
  display: string;
}
type DeviceValueKey = 'PC' | 'Tablet' | 'Mobile';
export type DeviceType = Range<0, 3>;
export const deviceValueMapping: Record<DeviceValueKey, DeviceType> = {
  PC: 0,
  Tablet: 1,
  Mobile: 2,
};
export interface IQuestionReviewType {
  questionParams: CombineTypeAnswer;
  deviceValue?: DeviceType;
  fieldIndex?: number;
  disabled?: boolean;
  isQuestionCentered?: boolean;
  isActiveHighlight?: boolean; // check whether features hight question is active
  questionIndexInUI?: string;
}
export type TabMobileKey = 'normal' | 'scroll';
export const tabMobileMapping: { [key in TabMobileKey]: TabMobileKey } = {
  normal: 'normal',
  scroll: 'scroll',
};

export const descriptionSurveyDefault = '';
export const thanksContentDefault = `
  ĐÃ HOÀN THÀNH!
 Câu trả lời của bạn đã được gửi thành công. Bạn có thể xem lại bài khảo sát đã làm ngay bây giờ.
`;

export const titleSurveyDefault = 'Khảo sát ý kiến khách hàng';

export interface ISurveySubmitData {
  questionID: string;
  questionTypeID?: string;
  isRequired?: boolean;
  answerID?: string | string[];
  categoryID?: string;
  answerContent?: string | number;
  isMultipleSelect: boolean;
  answerColumnID?: null | { [x: string]: string | boolean };
  matrixCategoryID?: null | { [x: string]: string | string[] };
  answerColumnIDArr?: string[];
  iconType?: number;
}
export interface IAnsResultsArr {
  ansResults: ISurveySubmitData[];
}

export interface IFieldsForm {
  answerContent?: any;
  answerID?: string;
  categoryID?: string | string[];
  id: string;
  isRequired: boolean;
  questionID: string;
  questionTypeID: string;
  isMultipleSelect?: boolean;
  iconType?: number;
  answerColumnID?: { [x: string]: boolean | string | string[] } | null;
  matrixCategoryID?: { [x: string]: string[] } | null;
  answerColumnIDArr?: string[];
  isDropDown?: boolean;
  isCategory?: boolean;
}
export interface IMultipleAnswerForm {
  questionID: string;
  answerID: string;
  categoryID?: string | string[];
  answerContent?: string | number;
}

export interface IMatrixListAnswerForm {
  questionID: string;
  matrixCategoryID?: string | string[] | null;
  answerColumnID?: string;
}

type ErrorDoSurveyKeys =
  | 'defaultError'
  | 'surveyAllowOne'
  | 'surveyIsLocked'
  | 'surveyNotFound'
  | 'surveyNotAllow'
  | 'surveyErrorCallAPI'
  | 'surveyGetDataError'
  | 'noPeopleEvaluated';

export const ErrorDoSurveyMessageSelection: Record<ErrorDoSurveyKeys, string> = {
  defaultError:
    'Bạn không đủ điều kiện để làm bài khảo sát hoặc không thể tải bài khảo sát lúc này',
  surveyAllowOne: 'Bài khảo sát này chỉ làm được một lần.',
  surveyIsLocked: 'Bài khảo sát này chưa bắt đầu hoặc đã kết thúc.',
  surveyNotFound: 'Bài khảo sát không tồn tại.',
  surveyNotAllow: 'Bạn không có quyền làm bài khảo sát này.',
  surveyErrorCallAPI: 'Vui lòng thử lại sau',
  surveyGetDataError: 'Không thể tải thông tin bài khảo sát vào lúc này',
  noPeopleEvaluated: 'Không có người để được đánh giá',
};

export interface IClientInfo {
  countryCode: string;
  countryName: string;
  city: string;
  postal: string | number | null;
  latitude: string;
  longitude: string;
  iPv4: string;
  state: string;
  email: string;
  phone: string;
  userID: string;
}
export const clientInfoDefault = {
  countryCode: '',
  countryName: '',
  city: '',
  postal: '',
  latitude: '',
  longitude: '',
  iPv4: '',
  state: '',
  email: '',
  phone: '',
  userID: '',
};
export const defaultAnsResults = {
  questionID: '',
  answerID: '',
  categoryID: '',
  answerContent: '',
  answerColumnID: '',
  matrixCategoryID: '',
};
export interface IAnsResults {
  questionID: string;
  answerID: string;
  categoryID: string;
  answerContent: string;
  answerColumnID: string;
  matrixCategoryID: string | null;
}

export interface IRouterSurveyState {
  previousSurveyPath?: string;
  currentTab?: string;
  groupQuestions?: ISectionGroup | null;
}
export interface IRouteLoginState {
  isRedirectAfterLoginSSO: boolean;
}

export const questionNoSectionTittle = 'INIT_GROUP_QUESTION';

export interface IPositionData {
  start: number;
  end: number;
}

export interface IFormData {
  questionID: string;
  questionTypeID: string;
  isRequired: boolean;
  answerID?: string | null;
  categoryID?: string | string[];
  answerContent?: string;
  isDropDown?: boolean;
  iconType?: number | string;
  answerColumnID?: null;
  isMultipleSelect?: boolean;
  answerColumnIDArr?: string[];
  isCategory?: boolean;
}

export interface IDataFormatted {
  questionID: string;
  categoryID?: string;
  answerID?: string;
  answerContent?: string;
  answerColumnID?: string;
  matrixCategoryID?: string | null;
}

interface ISurveyPublicInfos extends IClientInfo {
  email: string;
  surveyID: string;
  phone: string;
}

export interface IDataSubmitSurvey {
  surveyID: string;
  startTime: string;
  conditionID: string;
  ansResults: IAnsResults[];
  surveyPublicInfos: ISurveyPublicInfos;
}

export interface IBranchQuestion {
  currentQuestionID: string;
  nextQuestionID: string;
  nextQuestionIDArray: string[];
}

export const branchQuestionDefault: IBranchQuestion = {
  currentQuestionID: '',
  nextQuestionID: '',
  nextQuestionIDArray: [],
};

export const messageErrorText = {
  errorGetInfoClient: 'Không thể lấy thông tin trình duyệt',
  notAllowDoSurvey: 'Không có quyền làm bài khảo sát',
  otherErrorCantNotDoSurvey: 'Không đủ điều kiện bài khảo sát',
  noEvaluatedPeople: 'Không có người được đánh giá',
  errorGetQuestionSurvey: 'Không thể tải được câu hỏi bài khảo sát',
  userNotLogin: 'Cần đăng nhập để thực hiện bài khảo sát',
  noQualifiedDoSurvey: 'Bài khảo sát chưa đủ điều kiện để làm bài khảo sát',
  errorGetInfoSurvey: 'Không thể tải được thông tin bài khảo sát',
  noPeopleEvaluated: 'Không có người để được đánh giá',
};
export const defaultGroupQuestion = {
  ['INIT_GROUP_QUESTION']: {
    sectionName: 'INIT_GROUP_QUESTION',
    question: [],
  },
};

export type IListBranchInfo = Record<string, string[]>;

export interface IDateTimeSubmit {
  questionID: string;
  answerContent: string;
  questionTypeID: string;
}

export type TQuestionRefInfo = Record<string, any>;

export const HIGHLIGHT_QUESTION_FOR_BRANCH_QUESTION = 'highlightQuestionForBranchQuestion'; // used for highlight question in case answer branch question

export const IS_PRIORITY_CLICK_HIGHLIGHT = 'isPriorityClickHighlight'; // flag check user click to question not highlight
